import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FolderPlus from '@scope/scope-one-ui/assets/icons/folder-plus.svg';
import { IconTextButton, Widget } from '@scope/scope-one-ui/core';
import { PortfolioSummaryProps } from './PortfolioSummary.d';

import { PortfolioUploadModal } from '../../../Modals/PortfolioUpload/PortfolioUploadModal';
import { SummaryCard, SummaryTitle, WidgetsWrapper } from './PortfolioSummary.styled';
import { ItemsWidget } from './ItemsWidget';
import LastAddedWidget from './LastAddedWidget';
import PortfolioNewsWidget from './PortfolioNewsWidget';

export const PortfolioSummary: FC<PortfolioSummaryProps> = ({
  portfolioId,
  summary,
  noOfItems,
}) => {
  const { t } = useTranslation();
  const [portfolioUploadModalOpen, setPortfolioUploadModalOpen] = useState(false);

  const { lastAdded, latestNews } = summary ?? { lastAdded: [], latestNews: [] };

  const closeUploadPortfolioModal = () => {
    setPortfolioUploadModalOpen(false);
  };

  const uploadPortfolio = () => {
    setPortfolioUploadModalOpen(true);
  };

  return (
    <>
      <SummaryCard padded>
        <SummaryTitle variant="h2">{t('PORTFOLIO.PORTFOLIO_SUMMARY')}</SummaryTitle>
        <IconTextButton onClick={uploadPortfolio} icon={<FolderPlus />}>
          {t('PORTFOLIO.UPLOAD_PORTFOLIO')}
        </IconTextButton>
      </SummaryCard>
      <WidgetsWrapper>
        <ItemsWidget noOfItems={noOfItems} />
        {!!lastAdded.length && <LastAddedWidget portfolioId={portfolioId} lastAdded={lastAdded} />}
        {!!latestNews.length && <PortfolioNewsWidget latestNews={latestNews} />}
      </WidgetsWrapper>

      <PortfolioUploadModal
        open={portfolioUploadModalOpen}
        onClose={closeUploadPortfolioModal}
        destinationPortfolioId={portfolioId}
      />
    </>
  );
};

export default PortfolioSummary;
